//
//
//
//
//
//
//
//
//
//
//
//


export default {
    name: 'resterrors',
    props: {
        error: {
        type: Object,
        default: () => {},
        },
    },
}
